import { useEffect, useState } from 'react'
import Select from 'react-select'
import { FinancialYearDDLAPI, MonthDDLAPI, WardNameDDLAPI, WardNameGDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const WardnameHeaderDDL = (props) => {
    const { WardName, setWardName, M_ProjectTypeID } = props;

    const userDetails = useAuthState();
    const { Ward, setWard } = userDetails;
    const { UserID, token } = userDetails.user;

    const dispatch = useDispatch();

    const { WardNameGDDLDataa } = useSelector(
        state => state.WardNameGDDLData
    );
    useEffect(() => {

        console.log("M_ProjectTypeID changed ->", M_ProjectTypeID);
        setWard(prev => ({
            ...prev,
            ID: 0,
            Label: "Ward..."
        }));

        setWardName(prev => ({
            ...prev,
            ID: 0,
            Label: "Ward..."
        }));

        const data = {
            M_WardID: "0",
            M_ZoneID: "0",
            M_ProjectTypeID: M_ProjectTypeID || "0",
            Flag: "Master",
            M_UserID: UserID,
            token
        };

        dispatch(WardNameGDDLAPI({ data }));

    }, [M_ProjectTypeID]);

    useEffect(() => {

        if (
            WardNameGDDLDataa?.table &&
            WardNameGDDLDataa.table.length > 0
        ) {

            const list = WardNameGDDLDataa.table.map(item => ({
                value: item.m_WardID,
                label: item.wardName,
            }));

            const firstWard = list[0];

            setWardName({
                DDL: list,
                ID: firstWard.value,
                Label: firstWard.label,
            });

            setWard({
                DDL: list,
                ID: firstWard.value,
                Label: firstWard.label,
            });

            console.log("FIRST WARD SELECTED ->", firstWard);

        } else {

            setWardName({
                DDL: [],
                ID: 0,
                Label: "Ward...",
            });

            setWard({
                DDL: [],
                ID: 0,
                Label: "Ward...",
            });
        }

    }, [WardNameGDDLDataa]);
    const handleWardNameDDL = () => {

        if (WardNameGDDLDataa && WardNameGDDLDataa.table && WardNameGDDLDataa.table.length > 0) {
            let list = WardNameGDDLDataa.table.map((item) => ({
                value: item.m_WardID,
                label: item.wardName,
            }))

            if (Ward?.ID && Ward.ID != 0) {
                setWardName({
                    DDL: list,
                    ID: Ward.ID,
                    Label: Ward.Label,
                })
                setWard({
                    DDL: list,
                    ID: Ward.ID,
                    Label: Ward.Label,
                })
            } else {
                setWardName({
                    DDL: list,
                    ID: list[0].value,
                    Label: list[0].label,
                })
                setWard({
                    DDL: list,
                    ID: list[0].value,
                    Label: list[0].label,
                })
            }
        } else {
            setWardName({
                DDL: [],
                ID: 0,
                Label: "Ward...",
            })
        }
    }

    const handleChange = (e) => {
        setWardName({ ...WardName, ID: e.value, Label: e.label })
        setWard({ ...Ward, ID: e.value, Label: e.label })
    }

    return (
        <div className="form-group">
            <Select
                styles={{
                    control: (baseStyles, state) => ({
                        ...baseStyles,
                        borderColor: '#878181',
                        boxShadow: 'none',
                        width: '100%'
                    }),
                    option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isSelected
                            ? '#2684FF'
                            : state.isFocused
                                ? '#DEEBFF'
                                : 'white',
                        color: state.isSelected ? 'white' : 'black',
                        cursor: 'pointer',
                    }),
                    menu: (provided) => ({
                        ...provided,
                        backgroundColor: 'white',
                        zIndex: 9999,
                    }),
                }}
                components={{
                    IndicatorSeparator: () => null
                }}
                value={{ value: WardName.ID, label: WardName.Label }}
                onChange={(e) => {
                    e ?
                        handleChange(e)
                        :
                        setWardName({ ...WardName, ID: 0, Label: "Ward..." })
                }}
                options={WardName.DDL}
            />
        </div>
    )
}